<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-md min-w-full table-example">
        <div class="grid grid-cols-10 bg-gray-50">
            <div class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">Item</div>
            <div class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">Description</div>
            <div class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">Supplier</div>
            <div class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">Sell Total</div>
            <div class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">Buy Total</div>
            <div class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">Profit</div>
            <div class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider">Profit %</div>
        </div>

        <NestedDraggable :services="services"/>
    </div>
</template>

<script>
import {CalendarIcon, LocationMarkerIcon, UsersIcon, FolderIcon} from '@heroicons/vue/solid'
import NestedDraggable from "@/Components/NestedDraggable";

const services = [
    {
        id: 1,
        type: 'folder',
        name: 'Accommodation',
        description: 'This is a test description',
        sell_total: 1000,
        buy_total: 500,
        profit: 500,
        profit_percentage: 100,
        depth: 0,
        children: [
            {
                id: 1,
                type: 'folder',
                name: 'Hotel Gotham',
                description: 'A luxurious boutique hotel',
                sell_total: 1000,
                buy_total: 500,
                profit: 500,
                profit_percentage: 100,
                depth: 1,
                children: [
                    {
                        id: 1,
                        type: 'service',
                        name: 'Penthouse Suite',
                        description: 'For the manager',
                        sell_total: 1000,
                        buy_total: 500,
                        profit: 500,
                        profit_percentage: 100,
                        depth: 2,
                        client: {
                            name: 'Test'
                        },
                    },
                    {
                        id: 1,
                        type: 'service',
                        name: 'King Suite',
                        description: 'For the players',
                        sell_total: 10000,
                        buy_total: 8000,
                        profit: 2000,
                        profit_percentage: 20,
                        depth: 2,
                        client: {
                            name: 'Test'
                        },
                    }
                ]
            },
            {
                id: 1,
                type: 'folder',
                name: 'Lowry Hotel',
                description: 'A luxurious boutique hotel',
                sell_total: 1000,
                buy_total: 500,
                profit: 500,
                profit_percentage: 100,
                depth: 1,
                children: [
                    {
                        id: 1,
                        type: 'service',
                        name: 'Penthouse Suite',
                        description: 'For the manager',
                        sell_total: 1000,
                        buy_total: 500,
                        profit: 500,
                        profit_percentage: 100,
                        depth: 2,
                        client: {
                            name: 'Test'
                        },
                    },
                    {
                        id: 1,
                        type: 'service',
                        name: 'King Suite',
                        description: 'For the players',
                        sell_total: 10000,
                        buy_total: 8000,
                        profit: 2000,
                        profit_percentage: 20,
                        depth: 2,
                        client: {
                            name: 'Test'
                        },
                    }
                ]
            }
        ]
    },
    {
        id: 1,
        type: 'folder',
        name: 'Travel',
        description: 'This is a travel description',
        sell_total: 1000,
        buy_total: 500,
        profit: 500,
        profit_percentage: 100,
        depth: 0,
        children: [
            {
                id: 1,
                type: 'folder',
                name: 'Flights',
                description: 'This is a flights description',
                sell_total: 1000,
                buy_total: 500,
                profit: 500,
                profit_percentage: 100,
                depth: 1,
                children: [
                    {
                        id: 1,
                        type: 'service',
                        name: 'Manchester to London',
                        description: 'Outbound flights',
                        sell_total: 1000,
                        buy_total: 500,
                        profit: 500,
                        profit_percentage: 100,
                        depth: 2,
                        client: {
                            name: 'Test'
                        },
                    },
                    {
                        id: 1,
                        type: 'service',
                        name: 'London to Manchester',
                        description: 'Inbound flights',
                        sell_total: 1000,
                        buy_total: 500,
                        profit: 500,
                        profit_percentage: 100,
                        depth: 2,
                        client: {
                            name: 'Test'
                        },
                    }
                ]
            }
        ]
    }
]


export default {
    components: {
        NestedDraggable,
        CalendarIcon,
        LocationMarkerIcon,
        UsersIcon,
        FolderIcon
    },
    data() {
        return {
            services
        }
    }
}

</script>
